import { useMemo } from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import MDBox from "components/MDBox";
import { JobPhase } from "generated/graphql";
import { denseTableSx, headerCellSx } from "./utils";

export default function StatementOfWorkTable({ jobPhase }: { jobPhase: JobPhase }) {
  const statementOfWorkHtml = useMemo(() => {
    const html =
      jobPhase?.proposalProduct?.statementOfWork ||
      jobPhase?.proposalProduct?.material?.statementOfWork ||
      "";

    return typeof html === "string" ? html.trim() : "";
  }, [jobPhase]);

  if (!statementOfWorkHtml) {
    return null;
  }

  return (
    <MDBox mb={3} sx={{ "@media print": { marginBottom: 1 } }}>
      <TableContainer component={Paper}>
        <Table aria-label="statement of work" sx={denseTableSx}>
          <TableBody>
            <TableRow>
              <TableCell variant="head" sx={headerCellSx}>
                Job Phase Statement of Work
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <MDBox
                  sx={{
                    "& p": { margin: "0 0 8px 0" },
                    "& p:last-of-type": { marginBottom: 0 },
                    "& ul, & ol": { margin: "0 0 8px 18px", padding: 0 },
                    "& li": { marginBottom: "4px" },
                  }}
                  dangerouslySetInnerHTML={{ __html: statementOfWorkHtml }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </MDBox>
  );
}
